import { render } from "./SurveyPropertiesForm.vue?vue&type=template&id=b99b3958"
import script from "./SurveyPropertiesForm.vue?vue&type=script&lang=js"
export * from "./SurveyPropertiesForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__